// Libs
import React from 'react';
import { Typography } from '@mui/material';

// Components
import Layout from '../../../components/Layout';
import Spinner from '../../../components/Spinner';
import Feather from '../../../components/Feather';

// Hooks
import useUnauthorizedApprove from '../hooks/useUnauthorizedApprove';

import { useStyles } from './ApproveAllStyles';

const ApproveAll = () => {
  const { loading, message, responseType, status } = useUnauthorizedApprove();
  const { classes } = useStyles({
    isSuccessResponse: responseType === 'success',
  });

  return (
    <Layout hideHeaderLinks={true}>
      <div className={classes.container}>
        {loading ? (
          <Spinner />
        ) : (
          <>
            <div className={classes.icon}>
              <Feather nativeColor printType="stroke" type={responseType} />
            </div>
            {message && (
              <Typography textAlign="center" mt={3} variant="h2">
                {status === 'already_approved'
                  ? 'No changes can be made'
                  : message}
              </Typography>
            )}
            {status === 'already_approved' && (
              <span className={classes.centered}>{message}</span>
            )}
          </>
        )}
      </div>
    </Layout>
  );
};

export default ApproveAll;
